import KeptEquipmentPhoto from 'components/products/kept-equipment-photo';
import ProductPhoto from 'components/products/product-photo';
import { AirHandlerProductType, CondenserProductType } from 'data/types';
import { isEquipmentPlaceholderProduct } from 'utils/equipment-placeholder';

type DuctedLineSetPhotoProps = {
  product: CondenserProductType | AirHandlerProductType;
};

export default function DuctedLineSetPhoto({
  product
}: DuctedLineSetPhotoProps) {
  if (isEquipmentPlaceholderProduct(product)) {
    return <KeptEquipmentPhoto />;
  }
  return <ProductPhoto product={product} />;
}
